<template>
  <section>
    <vue-apex-charts
      class="trklnchart"
      ref="refTrackingLineChart"
      type="line"
      :height="chartHeight"
      :options="chartOptions"
      :series="series"
    />
    <news-search-modal 
      ref="newsSearchModal"
    />
    <dialog closedby="any" style="border: solid gray 1.5px; border-radius: 3px;">
      <div v-for="newsitem in news_datas" style="margin: 2px;">
        <div class="newsitem" @click="showNews(newsitem, false)">
          {{ newsitem.name }} ( {{ newsitem.date }})
          <slot />
        </div>
      </div>
    </dialog>
  </section>
</template>
  
<script>
import VueApexCharts from "vue-apexcharts";
import { debounce, __ } from 'lodash'
import moment from "moment";
import NewsSearchModal from "@/views/cis-keywordsearch/NewsSearchModal";
import FindPeak from "./findpeak.js"

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
const shapeMap = ['circle', 'triangle', 'square', 'sparkle', 'diamond'];

const localeFloatOpt = { minimumFractionDigits: 1, maximumFractionDigits: 1 };

var seriesFreq = [];
var seriesRate = [];  

var clickCount = 0;
  
export default {
  name: "TrackingLineChart",
  components: {
    VueApexCharts,
    NewsSearchModal,
  },
  data() {
    return {
      chartDisplayType: "",

      chartOptions: {
        chart: {
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          events: {
            mounted: function(chartContext, config) {
              chartContext.windowResizeHandler();
            },
            updated: function(chartContext, config) {
              debounce(() => {
                chartContext.windowResizeHandler();
              }, 500);
            },
            // legendClick 이벤트 리스너
            legendClick: function(chartContext, seriesIndex, config) {
              // 토글된 시리즈의 이름 가져오기
              const seriesName = config.config.series[seriesIndex].name;
              const isToggle = config.config.series[seriesIndex].hidden;
              var isSeriesHidden = false;

              // 해당 시리즈의 데이터 배열이 비어 있는지 확인하여 숨겨졌는지 판단
              if (isToggle)
                return true;
              
              var activeSeriesIdx = [];
              for (let i = 0; i < config.config.series.length; i++) {
                if (config.config.series[i].hidden)
                  continue;

                if (i === seriesIndex) {
                  if (config.config.series[i].data.length === 0)
                    activeSeriesIdx.push(i)
                }
                else {
                  if (config.config.series[i].data.length > 0)
                    activeSeriesIdx.push(i)
                }
              }

              var points = [];
              const parent_obj = config.globals.dom.baseEl.__vue__.$parent;

              for (const item of parent_obj.anno_datas) {
                if (activeSeriesIdx.indexOf(item.series_idx) >= 0) {
                  points.push({
                    x: item.x,
                    y: item.y,
                    seriesIndex: item.series_idx,
                    marker: {
                      size: 5,
                      fillColor: colorMap[item.series_idx % colorMap.length],
                      strokeColor: "#aaa",
                      strokeWidth: 3,
                      shape: shapeMap[Math.floor(item.series_idx / colorMap.length) % shapeMap.length]
                    },
                    click: function(config, event) {              
                      const parent = this.w.globals.dom.baseEl.__vue__.$parent;
                      const series_name = this.w.globals.seriesNames[config.seriesIndex];
                      const date = config.x;

                      if (clickCount === 2) {
                        parent.showNews(           
                          {
                            name: series_name, 
                            date: date
                          },
                          false
                        );

                        clickCount = 0;
                      }
                    }
                  })

                  const newAnno = {
                    x: item.x,
                    y: null,
                    yAxisIndex: 0,
                    marker: {
                      size: 0,
                    },
                    image: {
                      path: '/alarm.gif',
                      offsetY: -15,
                      width: 20,
                      height: 20,
                    },
                    click: parent_obj.showNewsList
                  };

                  const existAnno = points.filter((points) => {
                    if (points.x === newAnno.x && points.y === newAnno.y)
                      return false;
                    return true;
                  })
                
                  if (existAnno)
                    points.push(newAnno);
                }
              }

              const lineChartOption = {
                annotations: {
                  points: points
                },
              };

              chartContext.updateOptions(lineChartOption, true);
              
              // false를 반환하면 ApexCharts의 기본 동작(시리즈 토글)을 막을 수 있습니다.
              // true 또는 반환하지 않으면 기본 동작이 수행됩니다.
              return true;
            },
            dataPointSelection: function(event, chartContext, opts) {
              clickCount++; 

              setTimeout(function() {
                if (clickCount === 2) {
                  if (opts.seriesIndex >= 0 && opts.dataPointIndex >= 0) {
                    var searchKeyword = opts.w.globals.seriesNames[opts.seriesIndex];
                    var ref_dt = opts.w.globals.categoryLabels[opts.dataPointIndex];

                    if (!(searchKeyword == 'NONBRANDED' || searchKeyword == '기타' || searchKeyword == '중분류 없음')) {
                      chartContext.el.__vue__.$parent.showNews(
                        {
                          name: searchKeyword, 
                          date: ref_dt
                        },
                        true
                      )
                    }
                  }
                }

                clickCount = 0; // 초기화
              }, 250);
            },
          },
          animations: {
            enabled: false,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
                enabled: true,
                delay: 350
            },
            dynamicAnimation: {
                enabled: true,
                speed: 350
            }
          },
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'middle',
          formatter: function (value, opt) {
            if (opt.w.globals.dom.baseEl.__vue__.chartDisplayType === "비율(%)")
              return (Math.round(value * 10) / 10).toLocaleString(undefined, localeFloatOpt) + '%';
            else
              return (Math.round(value * 10) / 10).toLocaleString();
          },
          offsetY: -5,
          background: {
            enabled: false
          },
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1.5,
          curve: 'smooth',
        },
        markers: {
          size: 4,
          hover: {
            size: 5
          },
        },
        xaxis: {
          categories: [],
          tooltip: {
            enabled: false,
          },
          crosshairs: {
            show: true,
            dropShadow: {
                enabled: true,
                top: 0,
                left: 0,
                blur: 0,
                opacity: 0.4,
            },
          },
        },
        yaxis: [
          {
            min: 0,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                let val = Math.round(value * 10) / 10;

                if (val >= 10 ** 3 && val < 10 ** 6)
                  return (val / 1000).toLocaleString(undefined, localeFloatOpt) + 'K';
                else if (val >= 10 ** 6)
                  return (val / 1000000).toLocaleString(undefined, localeFloatOpt) + 'M';
                else
                  return (val).toLocaleString(undefined, localeFloatOpt);
              },
            },
            title: {
              text: 'Search Volume',
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        ],
        tooltip: {
          followCursor: true,
          shared: false,
          intersect: true,
          enabled: true,
          fixed: {
            enabled: false,
          },
          title: {
            fontSize: '6px'
          },
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            const seriesIdx = seriesIndex;
            const dataPtIdx = dataPointIndex;

            var hexColor = w.globals.colors[seriesIdx].replace('#', '')
            const r = parseInt(hexColor.substring(0, 2), 16)
            const g = parseInt(hexColor.substring(2, 4), 16)
            const b = parseInt(hexColor.substring(4, 6), 16)
            hexColor = `rgb(${r}, ${g}, ${b})`

            var customHTML = '<div>' +
              '<div class="apexcharts-tooltip-title" style="font-family: NanumBarunGothic; font-size: 12px;">' + w.globals.categoryLabels[dataPtIdx] + '</div>' +
              '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">' +
              '<span class="apexcharts-tooltip-marker" style="background-color: ' +  hexColor + ';"></span>' + 
              '<div class="apexcharts-tooltip-text" style="font-family: NanumBarunGothic; font-size: 12px;">' +
              '<div class="apexcharts-tooltip-y-group">' +
              '<span class="apexcharts-tooltip-text-label">' + w.globals.seriesNames[seriesIdx] + ' : ' + '</span>';

            if (w.globals.dom.baseEl.__vue__.$parent.chartDisplayType === "비율(%)") 
              customHTML += '<span class="apexcharts-tooltip-text-value">' + Number(seriesRate[seriesIdx].data[dataPtIdx]).toLocaleString(undefined, localeFloatOpt) + '%' + '</span>'
            else 
              customHTML += '<span class="apexcharts-tooltip-text-value">' + Number(seriesFreq[seriesIdx].data[dataPtIdx]).toLocaleString() + '</span>'

            customHTML += '</div>' +
              '<div class="apexcharts-tooltip-z-group">' +
              '<span class="apexcharts-tooltip-text-z-label"></span>' +
              '<span class="apexcharts-tooltip-text-z-value"></span>' +
              '</div></div></div></div>';
              return customHTML;
          },
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",
          itemMargin: {
            horizontal: 5,
            vertical: 2,
          },
          onItemClick: {
            toggleDataSeries: true
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },  

      series: [],
      anno_datas: [],
      news_datas: [],
    };
  },
  props: {
    trackingLineChart: {
      type: Array,
      default: () => [],
    },
    chartCategories: {
      type: Array,
      default: () => [],
    },
    chartHeight: {
      type: String,
      default: '100%',      
    },
    isChartInit: {
      type: Boolean,
      default: false,
    },
    chartPeriodType: {
      type: String,
      default: '100%',      
    },
  },
  computed: {
    check_displayType() {
      return this.$store.getters.getSelectedTrackingDisplayType;
    },

    check_periodType() {
      return this.$store.getters.getSelectedTrackingPeriodType;
    }
  },
  watch: {
    check_displayType(val) {
      let lineChartOption = null;
      this.chartDisplayType = val;

      if (this.chartDisplayType === "비율(%)") {
        this.series = seriesRate != null ? _.cloneDeep(seriesRate) : [];

        lineChartOption = {
          yaxis: {
            min: 0,
            max: 100,
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                return (Math.round(value * 100) / 100).toLocaleString(undefined, localeFloatOpt);
              },
            },
            title: {
              text: 'Search Volume',
              style: {
                color: "#008FFB",
              },
            },
          },
        };
      }
      else {
        this.series = seriesFreq != null ? _.cloneDeep(seriesFreq) : [];

        lineChartOption = {
          yaxis: {
            min: 0,
            max: undefined,
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                let val = Math.round(value * 10) / 10;

                if (val >= 10 ** 3 && val < 10 ** 6)
                  return (val / 1000).toLocaleString(undefined, localeFloatOpt) + 'K';
                else if (val >= 10 ** 6)
                  return (val / 1000000).toLocaleString(undefined, localeFloatOpt) + 'M';
                else
                  return (val).toLocaleString(undefined, localeFloatOpt);
              },
            },
            title: {
              text: 'Search Volume',
              style: {
                color: "#008FFB",
              },
            },
          },
        };
      }

      this.$refs.refTrackingLineChart.updateOptions(lineChartOption, true);  
    },

    check_periodType(val) {
      this.chartPeriodType = val
    },

    trackingLineChart(newVal) {
      if (!this.isChartInit) {
        this.series = [];

        const lineChartOption = {
          noData: {
            text: '분석중...',
            style: {
              color: '#1817E7',
            }
          },
        };

        this.$refs.refTrackingLineChart.updateOptions(lineChartOption, true);

        return;
      }    
     
      if (newVal.length > 0) {
        this.anno_datas = [];

        seriesFreq = _.cloneDeep(newVal);

        var totalFreqList = [];      
        for (let i = 0; i < this.chartCategories.length; i++) {
          var totalFreq = 0;

          for (const val of newVal) {
            if (val.data.length - 1 < i)
              totalFreq += 0;
            else
              totalFreq += Number(val.data[i])
          }

          totalFreqList.push(totalFreq)
        }

        seriesRate = _.cloneDeep(newVal);

        for (let i = 0; i < seriesRate.length; i++) {
          for (const j in seriesRate[i].data) {
            if (totalFreqList[j] > 0)
              seriesRate[i].data[j] = (Number(seriesRate[i].data[j]) / totalFreqList[j] * 100.0).toLocaleString(undefined, localeFloatOpt);
            else
              seriesRate[i].data[j] = 0;
          }
        }        
        
        if (this.chartDisplayType === "비율(%)")
          this.series = _.cloneDeep(seriesRate);
        else
          this.series = _.cloneDeep(seriesFreq);

        var colors = [];
        var shapes = [];
        
        for (let i = 0; i < newVal.length; i++) {
          shapes.push(shapeMap[Math.floor(i / colorMap.length) % shapeMap.length]);
          colors.push(colorMap[i % colorMap.length]);
        }

        const lineChartOption = {
          xaxis: {
            categories: this.chartCategories,
          },
          colors: colors,
          markers: {
            shape: shapes,
          },
          legend: {
            markers: {
              shape: shapes,
            }
          },
        };

        this.$refs.refTrackingLineChart.updateOptions(lineChartOption, true);

        if (this.chartPeriodType == '주')
          this.analysis();
      }
      else {
        this.series = [];

        const lineChartOption = {
          noData: {
            text: '해당하는 키워드가 없습니다.',
            style: {
              color: '#FF009C',
            }
          },
        };

        this.$refs.refTrackingLineChart.updateOptions(lineChartOption, true);
      }
    },

    anno_datas() {
      var points = [];

      for (const item of this.anno_datas) {
        points.push({
          x: item.x,
          y: item.y,
          seriesIndex: item.series_idx,
          marker: {
            size: 5,
            fillColor: colorMap[item.series_idx % colorMap.length],
            strokeColor: "#aaa",
            strokeWidth: 3,
            shape: shapeMap[Math.floor(item.series_idx / colorMap.length) % shapeMap.length],
          },
          click: function(opts, event) {    
            clickCount++;

            const parent = this.w.globals.dom.baseEl.__vue__.$parent;
            const series_name = this.w.globals.seriesNames[opts.seriesIndex];
            const date = opts.x;

            setTimeout(function() {
              if (clickCount === 2) {
                parent.showNews(           
                  {
                    name: series_name, 
                    date: date
                  },
                  false
                );
              }

              clickCount = 0;
            }, 250);
          }
        })

        const newAnno = {
          x: item.x,
          y: null,
          yAxisIndex: 0,
          marker: {
            size: 0,
          },
          image: {
            path: '/alarm.gif',
            offsetY: -15,
            width: 20,
            height: 20,
          },
          click: this.showNewsList
        };

        const existAnno = points.filter((points) => {
          if (points.x === newAnno.x && points.y === newAnno.y)
            return false;
          return true;
        })
      
        if (existAnno)
          points.push(newAnno);
      }

      const lineChartOption = {
        annotations: {
          points: points
        },
      };

      this.$refs.refTrackingLineChart.updateOptions(lineChartOption, true);
    }
  },
  methods: {
    async analysis() {
      this.anno_datas = [];

      var range_st = 0;
      var range_en = seriesFreq.length > 5 ? 5 : seriesFreq.length;

      let sum = 0;
      let cnt = 0;
      let th = 10000;

      for (let i = range_st; i < range_en; i++) {
        if (seriesFreq[i].name == 'NONBRANDED' || seriesFreq[i].name == '기타' || seriesFreq[i].name == '중분류 없음')
          continue;

        const tmp_data = seriesFreq[i].data.slice(0, -1)

        const min_val = tmp_data.reduce((min, current) => Math.min(min, current),  Infinity);

        sum += tmp_data.reduce((acc, val) => acc + (Number(val) - min_val), 0)
        cnt += tmp_data.length
      }

      if (sum > 0 && cnt > 0)
        th = Math.max(sum / cnt, 10000)

      // console.log("Spike Threshold : " + th)
     
      for (let i = range_st; i < range_en; i++) {
        if (seriesFreq[i].name == 'NONBRANDED' || seriesFreq[i].name == '기타' || seriesFreq[i].name == '중분류 없음')
          continue;

        // console.log("========== " + seriesFreq[i].name + " ==========")

        var peaks = this.find_peak(seriesFreq[i].data, th, { distance: 2 })
        
        if (peaks != null) {

          for (const idx of peaks) {
            // console.log(this.chartCategories[idx])
            // console.log(seriesFreq[i].data[idx])

            this.anno_datas.push({x: this.chartCategories[idx], y: seriesFreq[i].data[idx], series_idx: i})
          }
        }
      }
    },

    std(arr) {
      const n = arr.length;

      if (n === 0) 
        return 0;

      // 평균 계산
      const mean = arr.reduce((acc, val) => acc + Number(val), 0) / n;

      // 분산 계산 (표본 분산, n-1 사용)
      const variance = arr.reduce((acc, val) => acc + Math.pow(Number(val) - mean, 2), 0) / n;

      const max_val = arr.reduce((max, current) => Math.max(max, current), -Infinity);
      const min_val = arr.reduce((min, current) => Math.min(min, current),  Infinity);

      // 표준 편차 계산
      return {mean: mean, vari: variance, std: Math.sqrt(variance), max: max_val, min: min_val};
    },

    find_peak(data, th, options = {}) {
      const margin = 2;

      if (data.length < (margin * 2 + 1))
          return peaks; // Not enough data to find peaks

      const fp = new FindPeak(data);
      const out = fp.getSpikes();

      // console.log(fp)
      // console.log(out)

      const res_peak = out.filterByProperty(th, null, "left")

      // console.log(res_peak)

      return res_peak;
    },

    find_peak_ex(data, options = {}, limit) {
      const peaks = [];
      const { distance = 0 } = options;

      if (data.length < 3) {
          return peaks; // Not enough data to find peaks
      }

      const ref_range = 5;
      const margin = 2;

      for (let i = margin; i < data.length - margin; i++) {
        // const ref_st = i >= Math.floor(ref_range / 2) ? i - Math.floor(ref_range / 2) : 0;
        // const ref_en = ref_st + ref_range - 1 < data.length - Math.floor(ref_range / 2) ? ref_st + ref_range - 1 : data.length - Math.floor(ref_range / 2);

        if (Number(data[i]) < limit[i])
          continue;

        var ref_st = 0;
        var ref_en = 0;

        if (i <= Math.floor(ref_range / 2)) {
          ref_st = margin
          ref_en = ref_st + ref_range - 1;
        }
        else if (i >= (data.length - 1) - Math.floor(ref_range / 2)) {
          ref_en = data.length - margin - 1;
          ref_st = ref_en - ref_range - 1;
        }
        else {
          ref_st = i - Math.floor(ref_range / 2);
          ref_en = i + Math.floor(ref_range / 2);
        }      

        var sum = 0;
        var sdev_sum = 0;
        var avg = 0;
        var dev = [];
        var sdev = [];
        var vari = 0;
        var std = 0;

        for (let j = ref_st; j <= ref_en; j++) {
          sum += Number(data[j]);
        }

        avg = sum / ref_range;

        for (let j = ref_st; j <= ref_en; j++) {
          dev.push(Number(data[j]) - avg);
          sdev.push(Number(dev[dev.length - 1]) ** 2)

          sdev_sum += sdev[sdev.length - 1]
        }

        vari = sdev_sum / ref_range;
        std = Math.sqrt(vari)
       
        // Check for local maximum
        if (Number(data[i]) > Number(data[i - 1]) && Number(data[i]) > Number(data[i + 1])) {
          var z_score = (Number(data[i]) - avg) / std;

          // Check height condition
          if ((Number(data[i]) - Number(data[i - 1])) >= std * 2) {
            // Check distance condition
            let addPeak = true;

            if (distance > 0) {
              for (const existingPeakIndex of peaks) {
                if (Math.abs(i - existingPeakIndex) < distance) {
                  addPeak = false;
                  break;
                }
              }
            }

            if (addPeak) {
              peaks.push(i);
            }
          }
        }
      }

      return peaks;
    },

    find_local_min_max(data, options = {}) {
      const peaks = [];
      const { distance = 0 } = options;

      if (data.length < 3) {
        return peaks; // Not enough data to find peaks
      }

      for (let i = 1; i < data.length - 1; i++) {
        // Check for local maximum
        if (Number(data[i]) > Number(data[i - 1]) && Number(data[i]) > Number(data[i + 1])) {
          // Check distance condition
          let addPeak = true;

          if (distance > 0) {
            for (const existingPeakIndex of peaks) {
              if (Math.abs(i - existingPeakIndex) < distance) {
                addPeak = false;
                break;
              }
            }
          }

          if (addPeak) {
            peaks.push(i);
          }
        }

        // Check for local minimum
        if (Number(data[i]) < Number(data[i - 1]) && Number(data[i]) < Number(data[i + 1])) {
          // Check distance condition
          let addPeak = true;

          if (distance > 0) {
            for (const existingPeakIndex of peaks) {
              if (Math.abs(i - existingPeakIndex) < distance) {
                addPeak = false;
                break;
              }
            }
          }

          if (addPeak) {
            peaks.push(i);
          }
        }
      }

      return peaks;
    },

    showNewsList(event, chartContext, config) {
      var dialog_ctrl = document.querySelector('dialog');

      this.news_datas = [];

      for(let i = 0; i < this.anno_datas.length; i++) {
        if (this.$children[0].$el.__vue__.chart.series.w.config.series[this.anno_datas[i].series_idx].data.length === 0)
          continue;

        if (this.anno_datas[i].x == event.x) {         
          this.news_datas.push({
            name: this.series[this.anno_datas[i].series_idx].name, 
            date: this.anno_datas[i].x
          })
        }
      }

      var anno_rc = chartContext.target.getBoundingClientRect();
      var view_rc = chartContext.target.viewportElement.getBoundingClientRect();

      var pos_x = anno_rc.x - view_rc.x + 22
      var pos_y = anno_rc.y - view_rc.y + 20

      dialog_ctrl.style.left = (pos_x) + 'px';
      dialog_ctrl.style.top = (pos_y) + 'px';

      dialog_ctrl.show()
    },

    async showNews(item, isHideChart) {
      var st_dt = moment(item.date).add(-1, 'week').add( 1, 'day').format('YYYYMMDD')
      var en_dt = moment(item.date).add( 1, 'week').add(-1, 'day').format('YYYYMMDD')
     
      var chartData = await this.$parent.getSearchVolDiff(item.name, item.date);

      this.$nextTick(() => {
        this.$refs.newsSearchModal.loadData(item.name, st_dt, en_dt, chartData, isHideChart);
        this.$bvModal.show("news-search-modal");
      });      

      var dialog_ctrl = document.querySelector('dialog');
      dialog_ctrl.close()
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.trklnchart .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {
  color: #6e6b7b !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  padding-left: 0px;
}

.trklnchart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.trklnchart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.trklnchart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}

.trklnchart .apexcharts-canvas .apexcharts-text {
  font-family: NanumBarunGothicB !important;
}

.newsitem {
  display: block;
  width: 100%;
  padding: 2px 10px;
  transition: 0.1s;
  position: relative;
  color: #3c3c3b;
  cursor: pointer;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  font-family: NanumBarunGothic !important;
  text-align: right;
  white-space: nowrap;
  border-radius: 3px;
}

.newsitem:hover {
  background-color: #1951DC;
  color: #f0f0f0;
  transition: 0.1s;
}
</style>
  